/** World countries with dial codes for checkout phone + billing. Auto-generated — run scripts/gen-world-countries.mjs to refresh. */
export type WorldCountry = {
  iso2: string;
  name: string;
  dialCode: string;
  nationalLength: number;
};

export function isoToFlag(iso2: string): string {
  const code = iso2.toUpperCase();
  if (code.length !== 2) return '🏳️';
  return String.fromCodePoint(...[...code].map((c) => 127397 + c.charCodeAt(0)));
}

export const WORLD_COUNTRIES: WorldCountry[] = [
  { iso2: 'AF', name: "Afghanistan", dialCode: '+93', nationalLength: 9 },
  { iso2: 'AL', name: "Albania", dialCode: '+355', nationalLength: 9 },
  { iso2: 'DZ', name: "Algeria", dialCode: '+213', nationalLength: 9 },
  { iso2: 'AD', name: "Andorra", dialCode: '+376', nationalLength: 6 },
  { iso2: 'AO', name: "Angola", dialCode: '+244', nationalLength: 9 },
  { iso2: 'AG', name: "Antigua and Barbuda", dialCode: '+1268', nationalLength: 10 },
  { iso2: 'AR', name: "Argentina", dialCode: '+54', nationalLength: 10 },
  { iso2: 'AM', name: "Armenia", dialCode: '+374', nationalLength: 8 },
  { iso2: 'AU', name: "Australia", dialCode: '+61', nationalLength: 9 },
  { iso2: 'AT', name: "Austria", dialCode: '+43', nationalLength: 10 },
  { iso2: 'AZ', name: "Azerbaijan", dialCode: '+994', nationalLength: 9 },
  { iso2: 'BS', name: "Bahamas", dialCode: '+1242', nationalLength: 10 },
  { iso2: 'BH', name: "Bahrain", dialCode: '+973', nationalLength: 8 },
  { iso2: 'BD', name: "Bangladesh", dialCode: '+880', nationalLength: 10 },
  { iso2: 'BB', name: "Barbados", dialCode: '+1246', nationalLength: 10 },
  { iso2: 'BY', name: "Belarus", dialCode: '+375', nationalLength: 9 },
  { iso2: 'BE', name: "Belgium", dialCode: '+32', nationalLength: 9 },
  { iso2: 'BZ', name: "Belize", dialCode: '+501', nationalLength: 7 },
  { iso2: 'BJ', name: "Benin", dialCode: '+229', nationalLength: 8 },
  { iso2: 'BT', name: "Bhutan", dialCode: '+975', nationalLength: 8 },
  { iso2: 'BO', name: "Bolivia", dialCode: '+591', nationalLength: 8 },
  { iso2: 'BA', name: "Bosnia and Herzegovina", dialCode: '+387', nationalLength: 8 },
  { iso2: 'BW', name: "Botswana", dialCode: '+267', nationalLength: 8 },
  { iso2: 'BR', name: "Brazil", dialCode: '+55', nationalLength: 11 },
  { iso2: 'BN', name: "Brunei", dialCode: '+673', nationalLength: 7 },
  { iso2: 'BG', name: "Bulgaria", dialCode: '+359', nationalLength: 9 },
  { iso2: 'BF', name: "Burkina Faso", dialCode: '+226', nationalLength: 8 },
  { iso2: 'BI', name: "Burundi", dialCode: '+257', nationalLength: 8 },
  { iso2: 'CV', name: "Cabo Verde", dialCode: '+238', nationalLength: 7 },
  { iso2: 'KH', name: "Cambodia", dialCode: '+855', nationalLength: 9 },
  { iso2: 'CM', name: "Cameroon", dialCode: '+237', nationalLength: 9 },
  { iso2: 'CA', name: "Canada", dialCode: '+1', nationalLength: 10 },
  { iso2: 'CF', name: "Central African Republic", dialCode: '+236', nationalLength: 8 },
  { iso2: 'TD', name: "Chad", dialCode: '+235', nationalLength: 8 },
  { iso2: 'CL', name: "Chile", dialCode: '+56', nationalLength: 9 },
  { iso2: 'CN', name: "China", dialCode: '+86', nationalLength: 11 },
  { iso2: 'CO', name: "Colombia", dialCode: '+57', nationalLength: 10 },
  { iso2: 'KM', name: "Comoros", dialCode: '+269', nationalLength: 7 },
  { iso2: 'CG', name: "Congo", dialCode: '+242', nationalLength: 9 },
  { iso2: 'CD', name: "Congo (DRC)", dialCode: '+243', nationalLength: 9 },
  { iso2: 'CR', name: "Costa Rica", dialCode: '+506', nationalLength: 8 },
  { iso2: 'CI', name: "Cote d'Ivoire", dialCode: '+225', nationalLength: 8 },
  { iso2: 'HR', name: "Croatia", dialCode: '+385', nationalLength: 9 },
  { iso2: 'CU', name: "Cuba", dialCode: '+53', nationalLength: 8 },
  { iso2: 'CY', name: "Cyprus", dialCode: '+357', nationalLength: 8 },
  { iso2: 'CZ', name: "Czech Republic", dialCode: '+420', nationalLength: 9 },
  { iso2: 'DK', name: "Denmark", dialCode: '+45', nationalLength: 8 },
  { iso2: 'DJ', name: "Djibouti", dialCode: '+253', nationalLength: 8 },
  { iso2: 'DM', name: "Dominica", dialCode: '+1767', nationalLength: 10 },
  { iso2: 'DO', name: "Dominican Republic", dialCode: '+1809', nationalLength: 10 },
  { iso2: 'EC', name: "Ecuador", dialCode: '+593', nationalLength: 9 },
  { iso2: 'EG', name: "Egypt", dialCode: '+20', nationalLength: 10 },
  { iso2: 'SV', name: "El Salvador", dialCode: '+503', nationalLength: 8 },
  { iso2: 'GQ', name: "Equatorial Guinea", dialCode: '+240', nationalLength: 9 },
  { iso2: 'ER', name: "Eritrea", dialCode: '+291', nationalLength: 7 },
  { iso2: 'EE', name: "Estonia", dialCode: '+372', nationalLength: 8 },
  { iso2: 'SZ', name: "Eswatini", dialCode: '+268', nationalLength: 8 },
  { iso2: 'ET', name: "Ethiopia", dialCode: '+251', nationalLength: 9 },
  { iso2: 'FJ', name: "Fiji", dialCode: '+679', nationalLength: 7 },
  { iso2: 'FI', name: "Finland", dialCode: '+358', nationalLength: 10 },
  { iso2: 'FR', name: "France", dialCode: '+33', nationalLength: 9 },
  { iso2: 'GA', name: "Gabon", dialCode: '+241', nationalLength: 8 },
  { iso2: 'GM', name: "Gambia", dialCode: '+220', nationalLength: 7 },
  { iso2: 'GE', name: "Georgia", dialCode: '+995', nationalLength: 9 },
  { iso2: 'DE', name: "Germany", dialCode: '+49', nationalLength: 11 },
  { iso2: 'GH', name: "Ghana", dialCode: '+233', nationalLength: 9 },
  { iso2: 'GR', name: "Greece", dialCode: '+30', nationalLength: 10 },
  { iso2: 'GD', name: "Grenada", dialCode: '+1473', nationalLength: 10 },
  { iso2: 'GT', name: "Guatemala", dialCode: '+502', nationalLength: 8 },
  { iso2: 'GN', name: "Guinea", dialCode: '+224', nationalLength: 9 },
  { iso2: 'GW', name: "Guinea-Bissau", dialCode: '+245', nationalLength: 9 },
  { iso2: 'GY', name: "Guyana", dialCode: '+592', nationalLength: 7 },
  { iso2: 'HT', name: "Haiti", dialCode: '+509', nationalLength: 8 },
  { iso2: 'HN', name: "Honduras", dialCode: '+504', nationalLength: 8 },
  { iso2: 'HK', name: "Hong Kong", dialCode: '+852', nationalLength: 8 },
  { iso2: 'HU', name: "Hungary", dialCode: '+36', nationalLength: 9 },
  { iso2: 'IS', name: "Iceland", dialCode: '+354', nationalLength: 7 },
  { iso2: 'IN', name: "India", dialCode: '+91', nationalLength: 10 },
  { iso2: 'ID', name: "Indonesia", dialCode: '+62', nationalLength: 11 },
  { iso2: 'IR', name: "Iran", dialCode: '+98', nationalLength: 10 },
  { iso2: 'IQ', name: "Iraq", dialCode: '+964', nationalLength: 10 },
  { iso2: 'IE', name: "Ireland", dialCode: '+353', nationalLength: 9 },
  { iso2: 'IL', name: "Israel", dialCode: '+972', nationalLength: 9 },
  { iso2: 'IT', name: "Italy", dialCode: '+39', nationalLength: 10 },
  { iso2: 'JM', name: "Jamaica", dialCode: '+1876', nationalLength: 10 },
  { iso2: 'JP', name: "Japan", dialCode: '+81', nationalLength: 10 },
  { iso2: 'JO', name: "Jordan", dialCode: '+962', nationalLength: 9 },
  { iso2: 'KZ', name: "Kazakhstan", dialCode: '+7', nationalLength: 10 },
  { iso2: 'KE', name: "Kenya", dialCode: '+254', nationalLength: 9 },
  { iso2: 'KI', name: "Kiribati", dialCode: '+686', nationalLength: 5 },
  { iso2: 'KW', name: "Kuwait", dialCode: '+965', nationalLength: 8 },
  { iso2: 'KG', name: "Kyrgyzstan", dialCode: '+996', nationalLength: 9 },
  { iso2: 'LA', name: "Laos", dialCode: '+856', nationalLength: 10 },
  { iso2: 'LV', name: "Latvia", dialCode: '+371', nationalLength: 8 },
  { iso2: 'LB', name: "Lebanon", dialCode: '+961', nationalLength: 8 },
  { iso2: 'LS', name: "Lesotho", dialCode: '+266', nationalLength: 8 },
  { iso2: 'LR', name: "Liberia", dialCode: '+231', nationalLength: 8 },
  { iso2: 'LY', name: "Libya", dialCode: '+218', nationalLength: 9 },
  { iso2: 'LI', name: "Liechtenstein", dialCode: '+423', nationalLength: 7 },
  { iso2: 'LT', name: "Lithuania", dialCode: '+370', nationalLength: 8 },
  { iso2: 'LU', name: "Luxembourg", dialCode: '+352', nationalLength: 9 },
  { iso2: 'MO', name: "Macao", dialCode: '+853', nationalLength: 8 },
  { iso2: 'MG', name: "Madagascar", dialCode: '+261', nationalLength: 9 },
  { iso2: 'MW', name: "Malawi", dialCode: '+265', nationalLength: 9 },
  { iso2: 'MY', name: "Malaysia", dialCode: '+60', nationalLength: 10 },
  { iso2: 'MV', name: "Maldives", dialCode: '+960', nationalLength: 7 },
  { iso2: 'ML', name: "Mali", dialCode: '+223', nationalLength: 8 },
  { iso2: 'MT', name: "Malta", dialCode: '+356', nationalLength: 8 },
  { iso2: 'MH', name: "Marshall Islands", dialCode: '+692', nationalLength: 7 },
  { iso2: 'MR', name: "Mauritania", dialCode: '+222', nationalLength: 8 },
  { iso2: 'MU', name: "Mauritius", dialCode: '+230', nationalLength: 8 },
  { iso2: 'MX', name: "Mexico", dialCode: '+52', nationalLength: 10 },
  { iso2: 'FM', name: "Micronesia", dialCode: '+691', nationalLength: 7 },
  { iso2: 'MD', name: "Moldova", dialCode: '+373', nationalLength: 8 },
  { iso2: 'MC', name: "Monaco", dialCode: '+377', nationalLength: 8 },
  { iso2: 'MN', name: "Mongolia", dialCode: '+976', nationalLength: 8 },
  { iso2: 'ME', name: "Montenegro", dialCode: '+382', nationalLength: 8 },
  { iso2: 'MA', name: "Morocco", dialCode: '+212', nationalLength: 9 },
  { iso2: 'MZ', name: "Mozambique", dialCode: '+258', nationalLength: 9 },
  { iso2: 'MM', name: "Myanmar", dialCode: '+95', nationalLength: 10 },
  { iso2: 'NA', name: "Namibia", dialCode: '+264', nationalLength: 9 },
  { iso2: 'NR', name: "Nauru", dialCode: '+674', nationalLength: 7 },
  { iso2: 'NP', name: "Nepal", dialCode: '+977', nationalLength: 10 },
  { iso2: 'NL', name: "Netherlands", dialCode: '+31', nationalLength: 9 },
  { iso2: 'NZ', name: "New Zealand", dialCode: '+64', nationalLength: 9 },
  { iso2: 'NI', name: "Nicaragua", dialCode: '+505', nationalLength: 8 },
  { iso2: 'NE', name: "Niger", dialCode: '+227', nationalLength: 8 },
  { iso2: 'NG', name: "Nigeria", dialCode: '+234', nationalLength: 10 },
  { iso2: 'KP', name: "North Korea", dialCode: '+850', nationalLength: 10 },
  { iso2: 'MK', name: "North Macedonia", dialCode: '+389', nationalLength: 8 },
  { iso2: 'NO', name: "Norway", dialCode: '+47', nationalLength: 8 },
  { iso2: 'OM', name: "Oman", dialCode: '+968', nationalLength: 8 },
  { iso2: 'PK', name: "Pakistan", dialCode: '+92', nationalLength: 10 },
  { iso2: 'PW', name: "Palau", dialCode: '+680', nationalLength: 7 },
  { iso2: 'PS', name: "Palestine", dialCode: '+970', nationalLength: 9 },
  { iso2: 'PA', name: "Panama", dialCode: '+507', nationalLength: 8 },
  { iso2: 'PG', name: "Papua New Guinea", dialCode: '+675', nationalLength: 8 },
  { iso2: 'PY', name: "Paraguay", dialCode: '+595', nationalLength: 9 },
  { iso2: 'PE', name: "Peru", dialCode: '+51', nationalLength: 9 },
  { iso2: 'PH', name: "Philippines", dialCode: '+63', nationalLength: 10 },
  { iso2: 'PL', name: "Poland", dialCode: '+48', nationalLength: 9 },
  { iso2: 'PT', name: "Portugal", dialCode: '+351', nationalLength: 9 },
  { iso2: 'QA', name: "Qatar", dialCode: '+974', nationalLength: 8 },
  { iso2: 'RO', name: "Romania", dialCode: '+40', nationalLength: 9 },
  { iso2: 'RU', name: "Russia", dialCode: '+7', nationalLength: 10 },
  { iso2: 'RW', name: "Rwanda", dialCode: '+250', nationalLength: 9 },
  { iso2: 'KN', name: "Saint Kitts and Nevis", dialCode: '+1869', nationalLength: 10 },
  { iso2: 'LC', name: "Saint Lucia", dialCode: '+1758', nationalLength: 10 },
  { iso2: 'VC', name: "Saint Vincent and the Grenadines", dialCode: '+1784', nationalLength: 10 },
  { iso2: 'WS', name: "Samoa", dialCode: '+685', nationalLength: 7 },
  { iso2: 'SM', name: "San Marino", dialCode: '+378', nationalLength: 10 },
  { iso2: 'ST', name: "Sao Tome and Principe", dialCode: '+239', nationalLength: 7 },
  { iso2: 'SA', name: "Saudi Arabia", dialCode: '+966', nationalLength: 9 },
  { iso2: 'SN', name: "Senegal", dialCode: '+221', nationalLength: 9 },
  { iso2: 'RS', name: "Serbia", dialCode: '+381', nationalLength: 9 },
  { iso2: 'SC', name: "Seychelles", dialCode: '+248', nationalLength: 7 },
  { iso2: 'SL', name: "Sierra Leone", dialCode: '+232', nationalLength: 8 },
  { iso2: 'SG', name: "Singapore", dialCode: '+65', nationalLength: 8 },
  { iso2: 'SK', name: "Slovakia", dialCode: '+421', nationalLength: 9 },
  { iso2: 'SI', name: "Slovenia", dialCode: '+386', nationalLength: 8 },
  { iso2: 'SB', name: "Solomon Islands", dialCode: '+677', nationalLength: 7 },
  { iso2: 'SO', name: "Somalia", dialCode: '+252', nationalLength: 8 },
  { iso2: 'ZA', name: "South Africa", dialCode: '+27', nationalLength: 9 },
  { iso2: 'KR', name: "South Korea", dialCode: '+82', nationalLength: 10 },
  { iso2: 'SS', name: "South Sudan", dialCode: '+211', nationalLength: 9 },
  { iso2: 'ES', name: "Spain", dialCode: '+34', nationalLength: 9 },
  { iso2: 'LK', name: "Sri Lanka", dialCode: '+94', nationalLength: 9 },
  { iso2: 'SD', name: "Sudan", dialCode: '+249', nationalLength: 9 },
  { iso2: 'SR', name: "Suriname", dialCode: '+597', nationalLength: 7 },
  { iso2: 'SE', name: "Sweden", dialCode: '+46', nationalLength: 9 },
  { iso2: 'CH', name: "Switzerland", dialCode: '+41', nationalLength: 9 },
  { iso2: 'SY', name: "Syria", dialCode: '+963', nationalLength: 9 },
  { iso2: 'TW', name: "Taiwan", dialCode: '+886', nationalLength: 9 },
  { iso2: 'TJ', name: "Tajikistan", dialCode: '+992', nationalLength: 9 },
  { iso2: 'TZ', name: "Tanzania", dialCode: '+255', nationalLength: 9 },
  { iso2: 'TH', name: "Thailand", dialCode: '+66', nationalLength: 9 },
  { iso2: 'TL', name: "Timor-Leste", dialCode: '+670', nationalLength: 8 },
  { iso2: 'TG', name: "Togo", dialCode: '+228', nationalLength: 8 },
  { iso2: 'TO', name: "Tonga", dialCode: '+676', nationalLength: 7 },
  { iso2: 'TT', name: "Trinidad and Tobago", dialCode: '+1868', nationalLength: 10 },
  { iso2: 'TN', name: "Tunisia", dialCode: '+216', nationalLength: 8 },
  { iso2: 'TR', name: "Turkey", dialCode: '+90', nationalLength: 10 },
  { iso2: 'TM', name: "Turkmenistan", dialCode: '+993', nationalLength: 8 },
  { iso2: 'TV', name: "Tuvalu", dialCode: '+688', nationalLength: 6 },
  { iso2: 'UG', name: "Uganda", dialCode: '+256', nationalLength: 9 },
  { iso2: 'UA', name: "Ukraine", dialCode: '+380', nationalLength: 9 },
  { iso2: 'AE', name: "United Arab Emirates", dialCode: '+971', nationalLength: 9 },
  { iso2: 'GB', name: "United Kingdom", dialCode: '+44', nationalLength: 10 },
  { iso2: 'US', name: "United States", dialCode: '+1', nationalLength: 10 },
  { iso2: 'UY', name: "Uruguay", dialCode: '+598', nationalLength: 8 },
  { iso2: 'UZ', name: "Uzbekistan", dialCode: '+998', nationalLength: 9 },
  { iso2: 'VU', name: "Vanuatu", dialCode: '+678', nationalLength: 7 },
  { iso2: 'VA', name: "Vatican City", dialCode: '+39', nationalLength: 10 },
  { iso2: 'VE', name: "Venezuela", dialCode: '+58', nationalLength: 10 },
  { iso2: 'VN', name: "Vietnam", dialCode: '+84', nationalLength: 10 },
  { iso2: 'YE', name: "Yemen", dialCode: '+967', nationalLength: 9 },
  { iso2: 'ZM', name: "Zambia", dialCode: '+260', nationalLength: 9 },
  { iso2: 'ZW', name: "Zimbabwe", dialCode: '+263', nationalLength: 9 },
];

const BY_ISO = new Map(WORLD_COUNTRIES.map((c) => [c.iso2, c]));
const BY_NAME = new Map(WORLD_COUNTRIES.map((c) => [c.name.toLowerCase(), c]));
const BY_DIAL = new Map(
  [...WORLD_COUNTRIES].sort((a, b) => b.dialCode.length - a.dialCode.length).map((c) => [c.dialCode, c]),
);

export function getWorldCountry(iso2: string): WorldCountry {
  return BY_ISO.get(iso2.toUpperCase()) ?? BY_ISO.get('IN')!;
}

export function getWorldCountryByName(name: string): WorldCountry | undefined {
  const key = String(name || '').trim().toLowerCase();
  if (!key) return undefined;
  return BY_NAME.get(key);
}

export function searchWorldCountries(query: string, limit = 80): WorldCountry[] {
  const q = query.trim().toLowerCase();
  if (!q) return WORLD_COUNTRIES;
  const dialQ = q.startsWith('+') ? q : (/^\d+$/.test(q) ? `+${q}` : '');
  return WORLD_COUNTRIES.filter((c) => {
    if (dialQ && c.dialCode.startsWith(dialQ)) return true;
    return c.name.toLowerCase().includes(q)
      || c.iso2.toLowerCase().includes(q)
      || c.dialCode.includes(q);
  }).slice(0, limit);
}

export function parseStoredPhoneWorld(
  stored: string,
  fallbackIso2 = 'IN',
): { countryIso2: string; nationalDigits: string } {
  const raw = String(stored || '').trim();
  if (!raw) return { countryIso2: fallbackIso2, nationalDigits: '' };
  const digits = raw.replace(/\D/g, '');
  if (raw.startsWith('+')) {
    for (const [dial, country] of BY_DIAL) {
      const codeDigits = dial.replace(/\D/g, '');
      if (digits.startsWith(codeDigits)) {
        return {
          countryIso2: country.iso2,
          nationalDigits: digits.slice(codeDigits.length, codeDigits.length + country.nationalLength),
        };
      }
    }
  }
  if (digits.length === 10 && fallbackIso2 === 'IN') {
    return { countryIso2: 'IN', nationalDigits: digits };
  }
  const country = getWorldCountry(fallbackIso2);
  return { countryIso2: country.iso2, nationalDigits: digits.slice(-country.nationalLength) };
}

export function countryIsoFromBillingName(country?: string): string {
  return getWorldCountryByName(String(country || ''))?.iso2 ?? 'IN';
}
